import { feedStyles } from "./forum-feed.styles";
import * as stylex from "@stylexjs/stylex";
import { Alert, Button, EmptyState } from "@softmax/design-system";
import { RefreshFeedback } from "../forum-refresh-feedback";
import { ForumFeedRow } from "./forum-feed-row";
import type {
  ForumFeedState,
  ForumVote,
  ForumLinkRenderer,
} from "../forum.types";
export function ForumFeedResults({
  state,
  votes,
  onVote,
  postHref,
  renderLink,
  onLoadMore,
  onRefresh,
}: Readonly<{
  state: Extract<ForumFeedState, Readonly<{ status: "ready" }>>;
  votes: Readonly<Record<string, ForumVote>> | undefined;
  onVote(input: Readonly<{ postId: string; direction: 1 | -1 }>): void;
  postHref(postId: string): string;
  renderLink: ForumLinkRenderer;
  onLoadMore(): void;
  onRefresh(): void;
}>) {
  return (
    <>
      <RefreshFeedback
        refreshing={state.refreshing}
        error={state.refreshError}
        onRefresh={onRefresh}
      />
      {state.posts.length === 0 && (
        <EmptyState title="No posts yet">
          Players’ posts will appear here.
        </EmptyState>
      )}
      {state.posts.map((post) => (
        <ForumFeedRow
          key={post.id}
          post={post}
          vote={votes?.[post.id]}
          onVote={onVote}
          postHref={postHref}
          renderLink={renderLink}
        />
      ))}
      {(state.hasMore || state.loadMoreError) && (
        <div {...stylex.props(feedStyles.pagination)}>
          {state.loadMoreError && (
            <Alert tone="danger" announcement="assertive">
              {state.loadMoreError}
            </Alert>
          )}
          <Button
            aria-disabled={state.loadingMore}
            onClick={() => {
              if (!state.loadingMore) onLoadMore();
            }}
          >
            {state.loadingMore ? "Loading more…" : "Load more posts"}
          </Button>
        </div>
      )}
    </>
  );
}
